module.exports = __webpack_public_path__ + "static/media/H4_groot zuurstof.d9f3a06f.png";